(function () {
  var btn = document.querySelector('[data-menu-btn]');
  var drawer = document.getElementById('pbw-drawer');
  if (btn && drawer) {
    btn.addEventListener('click', function () {
      var open = drawer.classList.toggle('open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  var form = document.getElementById('pbw-product-form');
  if (!form) return;
  var planInput = form.querySelector('[data-plan-input]');
  var planSelect = form.querySelector('[data-plan-select]');
  var subPrice = form.querySelector('[data-sub-price]');
  var radios = form.querySelectorAll('[data-purchase]');

  function sync() {
    var sub = form.querySelector('[data-purchase]:checked');
    var isSub = sub && sub.value === 'sub';
    if (planInput) planInput.value = isSub && planSelect ? planSelect.value : '';
    if (planSelect && subPrice) {
      var opt = planSelect.options[planSelect.selectedIndex];
      if (opt && opt.getAttribute('data-price')) subPrice.textContent = opt.getAttribute('data-price');
    }
  }
  radios.forEach(function (r) { r.addEventListener('change', sync); });
  if (planSelect) {
    planSelect.addEventListener('change', function () {
      var subRadio = form.querySelector('[data-purchase][value="sub"]');
      if (subRadio) subRadio.checked = true;
      sync();
    });
  }
  sync();

  var qty = form.querySelector('[data-qty-input]');
  form.querySelectorAll('[data-qty]').forEach(function (b) {
    b.addEventListener('click', function () {
      var n = Math.max(1, (parseInt(qty.value, 10) || 1) + parseInt(b.getAttribute('data-qty'), 10));
      qty.value = n;
    });
  });
})();
